module.exports = __webpack_public_path__ + "img/Sentiments.daf15597.svg";